import React, { useState } from 'react';
import { FaSearch, FaTimesCircle } from 'react-icons/fa';
import $ from 'jquery';

import './style.scoped.scss';

const Search = ({ handleSearch, isDocument, placeholder = '', mobileLg, clearButton, searchOnType }) => {
  const [searchValue, setSearchValue] = useState('');

  const handleInput = (e) => {
    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      handleSearchClick(false);
    }
    setSearchValue(e.target.value);
    if (searchOnType) handleSearch(e.target.value);
  };

  const handleSearchClick = (isAdvanced) => {
    if (searchValue !== '') {
      $('[data-toggle="tooltip"]').tooltip('hide');
      handleSearch(searchValue, isAdvanced);
    }
  };

  $('[data-toggle="tooltip"]').tooltip();

  const clearSearch = () => {
    handleSearch('');
    setSearchValue('');
    $('[data-toggle="tooltip"]').tooltip('hide');
  }

  return (
    <div className={`search${mobileLg ? ' mobile-lg' : ''}`}>
      <input
        className="search__input"
        placeholder={`Search${placeholder}...`}
        id="searchItem"
        value={searchValue}
        onKeyDown={handleInput}
        onChange={handleInput}
      />
      {clearButton && searchValue.length > 0 ?
        <FaTimesCircle
          data-toggle="tooltip"
          title="Clear search"
          data-original-title="Clear search"
          className="mr-3"
          onClick={clearSearch}
        /> : null
      }
      {!searchOnType ? (
        <FaSearch
          onClick={() => handleSearchClick(false)}
          data-toggle={searchValue.length < 1 ? 'tooltip' : ''}
          title={searchValue.length < 1 ? 'Please enter a search term.' : 'Standard Search'}
          data-original-title={
            searchValue.length < 1 ? 'Please enter a search term.' : 'Standard Search'
          }
          className={`mx-2 search__click${searchValue.length > 0 ? '' : ' disabled'}`}
        />
      ) : null}
      {isDocument && (
        <div
          className={`search__advanced px-1 search__click${searchValue.length > 0 ? '' : ' disabled'
            }`}
          data-toggle={searchValue.length < 1 ? 'tooltip' : ''}
          title={searchValue.length < 1 ? 'Please enter a search term.' : ''}
          data-original-title={searchValue.length < 1 ? 'Please enter a search term.' : ''}
          onClick={() => handleSearchClick(true)}
        >
          <p className="m-0">Advanced</p>
        </div>
      )}
    </div>
  );
};

export default Search;
